import React from "react";
import "./customerTable.css";

const CustomerTable = ({ title }) => {
  // ** headings


  const tableData = {
    headings: ["ID", "User Name", "Date", "No of Projects Saved", "Project Name"],
    data: [
      {
        id: "#1235666",
        userName: "Iftikhar Yousaf Khan",
        date: "29/10/2023, 12:30 AM",
        saved: "18",
        pName: "Solar Structure Design Tool BH Smith",
      }
    ],
  };

  for (let i = 0; i < 10; i++) {
    tableData.data.push(tableData.data[0]);
  }

  return (
    <div className="pvxCustomerTable">
      <div className="title">
        <span>{title}</span>
        <div className="right">
          <div className="search-box">
            <img
              className="search-icon"
              src="../images/assets/search.png"
              alt="search icon"
            />
            <input
              className="input"
              type="text"
              placeholder="Search by User Name, Date"
            />
          </div>
          <img
            src="./images/PvxDashboard/Icons/Dots.svg"
            className="dots"
            alt="Dots"
          />
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            {tableData.headings.map((heading, index) => (
              <th key={index}>{heading}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.data.map((row, index) => (
            <tr key={index}>
              <td>{row.id}</td>
              <td>{row.userName}</td>
              <td>{row.date}</td>
              <td>{row.saved}</td>
              <td>{row.pName}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerTable;
